// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-thumbnail-canvas[data-v-1a51fe1a],.video-thumbnail-image[data-v-1a51fe1a]{display:block;width:100%;height:auto}.video-thumbnail-overlay[data-v-1a51fe1a]{position:relative;margin-top:-100%}.video-thumbnail-overlay img[data-v-1a51fe1a]{width:100%}", ""]);
// Exports
module.exports = exports;
